import { useMemo } from "react";

const CancelOrderSection = ({
    order,
    orderNo,
    cancelledFromPage,
    openModal
}) => {

    const allCancelable = useMemo(
        () =>
            order?.order_items?.length > 0 &&
            order.order_items.every((i) => i.allow_cancellation),
        [order]
    );

    const showCancelButton = allCancelable && !cancelledFromPage;

    if (!order) return null;

    return (
        <>
            {/* CANCEL BUTTON */}
            {showCancelButton && (
                <div className="order-box-cancel">
                    <span style={{ color: "#333", fontSize: "14px" }}>
                        Need to Cancel this Order ?
                    </span>

                    <button
                        className="cancelorder"
                        onClick={openModal}
                    >
                        Cancel Order
                    </button>
                </div>
            )}

            {/* CANCELLED STATUS */}
            {order?.order_status?.remarks === "Order Cancelled" && (
                <div className="order-box-cancel">
                    <h5 style={{ color: "#c81d1d", fontSize: "14px" }}>
                        {order.order_status.remarks}
                    </h5>

                    <span>As per your request on</span>
                </div>
            )}
        </>
    );
};

export default CancelOrderSection;